import { gql } from '@apollo/client';
import {
  AppsFragment,
  ActivityFragment,
  AssessmentFragment,
  BookFragment,
  ClientFragment,
  ClientGroupFragment,
  ClientLandingFragment,
  ProgramFragment,
  OrganizationFragment,
  PersonFragment,
  PodcastFragment,
  SourceFragment,
  TopicFragment,
  VideoFragment,
  LinkFragment,
  ListFragment,
  SeriesFragment,
  PracticesFragment,
  CourseFragment,
} from './fragments';

export default isPreviewMode => gql`
  ${ClientFragment}
  ${ClientGroupFragment}
  ${AppsFragment}
  ${ActivityFragment}
  ${AssessmentFragment}
  ${BookFragment}
  ${ClientLandingFragment}
  ${ProgramFragment}
  ${OrganizationFragment}
  ${PersonFragment}
  ${PodcastFragment}
  ${SourceFragment}
  ${TopicFragment}
  ${VideoFragment}
  ${LinkFragment}
  ${ListFragment}
  ${SeriesFragment}
  ${PracticesFragment}
  ${CourseFragment}
  query LandingResources($slug: String!, $locale: String!) {
    landingCollection(where: { slug: $slug }, limit: 1, locale: $locale, preview:${isPreviewMode}) {
      items {
        sys {
          id
        }
        featuredResourcesCollection (limit: 8) {
          items {
            ...ApplicationFields
            ...ActivityFields
            ...AssessmentFields
            ...BookFields
            ...ClientLandingFields
            ...ProgramFields
            ...OrganizationFields
            ...PersonFields
            ...PodcastFields
            ...SourceFields
            ...TopicsFields
            ...VideoFields
            ...ListFields
            ...LinkFields
            ...SeriesFields
            ...CoursesFields
            ...PracticesFields
          }
        }
        featuredCollageCollection (limit: 8) {
          items {
            ...ApplicationFields
            ...ActivityFields
            ...AssessmentFields
            ...BookFields
            ...ClientLandingFields
            ...ProgramFields
            ...OrganizationFields
            ...PersonFields
            ...PodcastFields
            ...SourceFields
            ...TopicsFields
            ...VideoFields
          }
        }
      }
    }
  }
`;
